import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-b border-b-black/[.10] py-3 flex items-center" }
const _hoisted_2 = { class: "text-xl text-left font-bold text-neutral-900" }
const _hoisted_3 = {
  key: 0,
  class: "group relative"
}
const _hoisted_4 = { class: "flex group-hover:visible invisible group-hover:opacity-100 opacity-0 transition absolute top-6 z-10 md:left-[-90px] md:right-[unset] right-0 bg-white p-3 shadow-md rounded text-left min-w-[230px]" }
const _hoisted_5 = { class: "space-y-6 text-left" }
const _hoisted_6 = { class: "flex justify-end items-center space-x-3" }

import BaseModal from '@/components/modals/BaseModal.vue';
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
import { InformationCircleIcon as InformationCircleIconSolid } from "@heroicons/vue/24/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentModal',
  props: {
    show: {
        type: Boolean
    },
    showInformation: {
        type: Boolean,
        default: false,
    },
    showInformationText: {
        type: String,
        default: '',
    },
    title: {
        type: String,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: "p-6 w-[480px] space-y-6",
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
        (__props.showInformation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(InformationCircleIcon), {
                class: "ml-2 w-6 h-6 text-neutral-900 shrink-0",
                "aria-hidden": "true"
              }),
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createVNode(_unref(InformationCircleIconSolid), {
                    class: "mr-1.5 w-5 h-5 text-blue-500 shrink-0",
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(__props.showInformationText), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "button")
      ])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})